import React from 'react';
import classnames from 'classnames';
import dayjs from 'dayjs';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const PublishedColumn = ColumnTree.defineNode(
  'published',
  ({ sortDirection, sortColumn, setSort }) => ({
    title: (
      <div>
        <a
          href="#published"
          className={classnames('icon-sort', 'sortem', {
            [sortDirection]: sortColumn === 'published',
          })}
          onClick={() => setSort('published')}
        >
          <FormattedMessage
            id="marketplace-table-heading-published"
            defaultMessage="Published at"
          />
        </a>
      </div>
    ),
    key: 'published',
    className: 'col-published',
    render: (text, record) => (
      <div className="td-content">
        <FormattedDate
          value={dayjs(record.published).toDate()}
          day="numeric"
          month="short"
          year="numeric"
        />{' '}
        <FormattedTime
          value={dayjs(record.published).toDate()}
          hour="2-digit"
          minute="2-digit"
          hour12={false}
        />
      </div>
    ),
  })
);
